export class EsiaPopupError extends Error {}
